// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

::ng-deep.profile_types {
  background-image: url("https://assets.foursightonline.com/app/images/foursight-profile-types.svg") !important;
  background-color: transparent;
  background-repeat: no-repeat;
  width: 34px;
  height: 15px;
  margin-left: 6px;
}

::ng-deep #holder > li {
  padding: 5px;
  margin: 2px;
  display: inline-block;
}

::ng-deep #holder > li[data-page] {
  border: solid #a0a0a0 1px;
  border-radius: 5px;
}

::ng-deep #holder > li.separator:before {
  content: "...";
}

::ng-deep #holder > li.active {
  background-color: darkblue;
  color: #fff;
}

::ng-deep #holder > li[data-page]:hover {
  cursor: pointer;
}

::ng-deep .checkbox {
  padding-left: 20px;
}
::ng-deep .pull-right {
  float: right !important;
}
::ng-deep .ibox-title.profile-heading-2 h5 {
  width: 100%;
  vertical-align: top;
}
::ng-deep .ibox-title.profile-heading-2 h5 ul.inline-list {
  padding: 0;
}
::ng-deep table.profile-layout.table-striped tr {
  background: #f1f1f2;
  border-left: 1px solid #d0d0d0;
  border-right: 1px solid #d0d0d0;
}
::ng-deep table.profile-layout.table-striped tr td {
  vertical-align: middle;
  white-space: nowrap;
}
::ng-deep table.profile-layout.table-striped tr th {
  vertical-align: middle;
  white-space: nowrap;
}
::ng-deep table.profile-layout.table-striped tr th span.sortby {
  width: 100%;
  height: 100%;
  text-align: right;
  display: block;
  position: absolute;
  right: 0;
  top: 14px;
  cursor: pointer;
  font-size: 16px;
}
::ng-deep table.profile-layout.table-striped tr th span.sortby.fname-asc, ::ng-deep table.profile-layout.table-striped tr th span.sortby.lname-asc, ::ng-deep table.profile-layout.table-striped tr th span.sortby.email-asc, ::ng-deep table.profile-layout.table-striped tr th span.sortby.org-asc, ::ng-deep table.profile-layout.table-striped tr th span.sortby.team-asc, ::ng-deep table.profile-layout.table-striped tr th span.sortby.profile-asc {
  top: 8px !important;
}
::ng-deep table.profile-layout.table-striped tr input {
  border: 1px solid #ccc;
  padding: 10px 8px;
  height: 34px;
}
::ng-deep table.profile-layout.table-striped tr input[type=checkbox] {
  height: auto !important;
}
::ng-deep table.profile-layout.table-striped tr select {
  border: 1px solid #ccc;
  padding: 7px 8px;
  height: 34px;
  min-width: 100px;
}
::ng-deep table.profile-layout.table-striped tr:nth-child(odd) {
  background: #fff;
}
::ng-deep table.profile-layout.table-striped tr a {
  color: #333;
}
::ng-deep table.profile-layout.table-striped tr a:hover {
  color: #337ab7;
}
::ng-deep table.profile-layout.table-striped tr a a.label.label-default {
  background: #474747;
  color: #fff !important;
}
::ng-deep table.profile-layout.table-striped tr:first-child th {
  background: #464646;
  color: #fff;
  padding: 10px 10px 5px 10px;
  white-space: nowrap;
}
::ng-deep table.profile-layout.table-striped tfoot tr {
  border: none !important;
}
::ng-deep ::ng-deep #holder li {
  border: 1px solid #ccc !important;
  border-radius: 0 !important;
  padding: 7px 11px;
}
::ng-deep ::ng-deep #holder li.active {
  background: #464646;
}
::ng-deep table.profile-layout.table-striped tr input[type=date]::-webkit-inner-spin-button,
::ng-deep table.profile-layout.table-striped tr input[type=date]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}
::ng-deep span.invitation-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 160px !important;
  overflow: hidden;
  display: block;
}
::ng-deep span.contact-lists {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100px !important;
  overflow: hidden;
  display: block;
}
::ng-deep a.orgs-lists {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80px !important;
  overflow: hidden;
  display: block;
}
::ng-deep .selectDataChild {
  width: 100%;
}
::ng-deep .selectDataChild tr:nth-child(odd) {
  background: #f1f1f2;
}
::ng-deep .selectDataChild th,
::ng-deep .selectDataChild td {
  padding: 5px 10px;
}
::ng-deep .selectDataChild th:last-child,
::ng-deep .selectDataChild td:last-child {
  text-align: center;
}
::ng-deep .reset-input th {
  position: relative;
}
::ng-deep .reset-input th input[type=search] {
  width: 100% !important;
}
::ng-deep .reset-input th .reset-close {
  display: none;
  position: absolute;
  top: 0;
  right: 25px;
  bottom: 0;
  margin: auto;
  border-radius: 50%;
  background: #ddd;
  border: none !important;
  text-align: center;
  font-size: 14px;
  padding: 0px !important;
  height: 16px !important;
  width: 16px !important;
  color: #fff;
  line-height: 1.2 !important;
  font-family: Arial !important;
  transform: rotate(45deg) !important;
  -webkit-transform: rotate(45deg) !important;
}
::ng-deep .reset-input th:hover .reset-close {
  display: block;
}
::ng-deep #templates {
  width: auto;
  height: 37px;
}
::ng-deep .btn-export-section,
::ng-deep #templates {
  display: inline-block;
  vertical-align: top;
}
::ng-deep .btn-export-section {
  padding-left: 15px;
}
::ng-deep ::ng-deep .btn-section {
  text-align: center;
  margin-top: 15px;
}
::ng-deep ::ng-deep.save-btn {
  display: inline-block;
  margin: 0 10px;
}
::ng-deep ::ng-deep.members {
  text-align: center;
}
::ng-deep ::ng-deep#parent-orgs {
  width: auto;
  display: inline-block;
  margin-bottom: 15px;
}
::ng-deep ::ng-deep.groups {
  padding-bottom: 10px;
}
::ng-deep ::ng-deep.groups-content .modal-dialog {
  width: 750px;
}
::ng-deep .column-up .list-group-item {
  width: 48%;
  display: inline-block;
  margin-right: 10px;
}
::ng-deep .column-up .list-group-item:nth-child(2n) {
  margin-right: 0;
}
::ng-deep .profile-layout th button {
  display: block;
  max-width: 94px;
  width: 100px;
  margin-bottom: 5px;
}
::ng-deep table.profile-layout.table-striped input[type=search] {
  min-width: 100px !important;
  width: 100% !important;
}
::ng-deep .inner-form-group {
  margin-bottom: 15px;
  margin-top: 15px;
}
::ng-deep .inner-form-group select {
  margin-top: 10px;
  margin-bottom: 10px;
}
::ng-deep .add-btn-pop {
  margin-right: 10px;
}
::ng-deep .cancel-add-to-org {
  margin-top: 0px !important;
}
::ng-deep .d-inline {
  display: inline-block;
  width: auto;
  clear: none;
}
::ng-deep .tick:before {
  content: "✓";
  color: darkgreen;
}
::ng-deep .cross:before {
  content: "✗";
  color: crimson;
}
::ng-deep .wide-per-page {
  width: 78px !important;
}
::ng-deep legend {
  width: auto;
  border: 0;
  color: #676a6c;
  margin: 0;
  font-size: 16px;
}
::ng-deep fieldset {
  border: 1px solid #ddd;
  padding: 18px;
  width: 100%;
  margin-bottom: 15px;
}
::ng-deep .form-group.session2 select {
  margin: 0 !important;
  width: 74px;
  height: 35px;
}
::ng-deep .form-group.session1 {
  float: left;
  padding: 0 10px;
  width: 100%;
}
::ng-deep .form-group.session2 {
  float: left;
  padding: 0 10px;
  width: 30%;
}
::ng-deep .add-session {
  margin-top: 15px;
}
::ng-deep .wizard > .steps {
  position: relative;
  display: block;
  width: 100%;
}
::ng-deep .wizard ul, ::ng-deep .tabcontrol ul {
  list-style: none !important;
  padding: 0;
  margin: 0;
  text-align: center;
}
::ng-deep .wizard > .steps > ul > li, ::ng-deep .wizard > .actions > ul > li {
  display: inline-block;
}
::ng-deep .wizard > .steps a, ::ng-deep .wizard > .steps a:hover, ::ng-deep .wizard > .steps a:active {
  display: block;
  width: auto;
  margin: 0 0.5em 0.5em;
  padding: 8px;
  text-decoration: none;
  border-radius: 5px;
}
::ng-deep .wizard > .steps .done a, ::ng-deep .wizard > .steps .done a:hover, ::ng-deep .wizard > .steps .done a:active {
  background: #ccc;
  color: #fff;
}
::ng-deep .wizard > .steps .active a {
  background: #676a6c !important;
}
::ng-deep ::ng-deep.previous-btn {
  background-color: rgb(105, 190, 40) !important;
  color: #fff !important;
}
::ng-deep .inner-form-group input[type=text] {
  display: block;
  width: 100%;
  margin-bottom: 15px;
}
::ng-deep .team-table {
  margin-top: 15px;
}

::ng-deep {
  /* HiDPI support */
}
::ng-deep .icheckbox_square-green,
::ng-deep .iradio_square-green {
  display: inline-block;
  *display: inline;
  vertical-align: middle;
  margin: 0;
  padding: 0;
  width: 22px;
  height: 22px;
  background: url("https://assets.foursightonline.com/app/images/green.png") no-repeat;
  border: none;
  cursor: pointer;
  margin-left: 0;
}
::ng-deep label {
  vertical-align: middle;
  margin-bottom: 0;
  margin-left: 7px;
}
::ng-deep .icheckbox_square-green {
  background-position: 0 0;
}
::ng-deep .icheckbox_square-green.hover {
  background-position: -24px 0;
}
::ng-deep .icheckbox_square-green.checked {
  background-position: -48px 0;
}
::ng-deep .icheckbox_square-green.disabled {
  background-position: -72px 0;
  cursor: default;
}
::ng-deep .icheckbox_square-green.checked.disabled {
  background-position: -96px 0;
}
::ng-deep .iradio_square-green {
  background-position: -120px 0;
}
::ng-deep .iradio_square-green.hover {
  background-position: -144px 0;
}
::ng-deep .iradio_square-green.checked {
  background-position: -168px 0;
}
::ng-deep .iradio_square-green.disabled {
  background-position: -192px 0;
  cursor: default;
}
::ng-deep .iradio_square-green.checked.disabled {
  background-position: -216px 0;
}
@media (min-resolution: 120dpi) {
  ::ng-deep .icheckbox_square-green,
  ::ng-deep .iradio_square-green {
    background-image: url("https://assets.foursightonline.com/app/images/green@2x.png");
    background-size: 240px 24px;
  }
}

.manage-members-wrapper {
  margin-bottom: 20px;
}
.manage-members-wrapper .manage-inner {
  float: none;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 15px;
}
.manage-members-wrapper .manage-inner h2 {
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 30px;
}
.manage-members-wrapper .manage-inner h3 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.manage-members-wrapper .manage-inner .inner-block {
  display: flex;
  display: -ms-flexbox;
  flex-wrap: wrap;
  -ms-flex-wrap: wrap;
}
@media screen and (max-width: 767px) {
  .manage-members-wrapper .manage-inner .inner-block .col-sm-4,
  .manage-members-wrapper .manage-inner .inner-block .col-sm-6 {
    margin-bottom: 15px;
  }
}
.manage-members-wrapper .manage-inner .inner-block .inner-single-box {
  padding: 15px;
  border: 3px solid #aaa;
  height: 100%;
  border-radius: 5px;
}
.manage-members-wrapper .manage-inner .inner-block .inner-single-box i {
  font-size: 60px;
}
.manage-members-wrapper .manage-inner .inner-block .inner-single-box ul {
  margin-top: 40px;
}
.manage-members-wrapper .manage-inner .inner-block .inner-single-box ul li:first-child {
  padding-bottom: 10px;
}
.manage-members-wrapper .manage-inner .inner-block .inner-single-box ul li:nth-child(2) {
  font-size: 14px;
}
.manage-members-wrapper .manage-inner .inner-block .inner-single-box ul li:nth-child(3) {
  margin-top: 10px;
}
.manage-members-wrapper .manage-inner .bottom-member {
  padding-top: 15px;
  padding-bottom: 15px;
}

.add-mbr-block .inner-single-box {
  position: relative;
  padding-bottom: 35px !important;
}
.add-mbr-block h5 {
  position: absolute;
  left: 0;
  bottom: 4px;
  right: 0;
}

.manage-profile-txt tr td {
  text-align: left;
}
.manage-profile-txt tr td:last-child, .manage-profile-txt tr th:last-child {
  text-align: center !important;
}

.ibox.ibox-member-dropdown {
  box-shadow: none;
}

.border-green {
  border-color: #86b74b !important;
}

::ng-deep .iradio_square-green {
  float: right;
}

.fname-column, .lname-column {
  text-transform: capitalize;
}

.first_name:focus,
.last_name:focus,
.wide-per-page:focus {
  outline: none;
  border-color: #1ab394;
}

.table-responsive {
  overflow-x: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/components/org-individual-members/org-individual-members.component.scss","webpack://./src/assets/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACgIhB;EACE,eAAA;AD9HF;;ACiIA;EACE,aAAA;EACA,eAAA;AD9HF;;ACiIA;EACE,sBAAA;AD9HF;;ACiIA;EACE,8BAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;ACiIA;EACE,aAAA;AD9HF;;ACiIA;EACE,gBAAA;AD9HF;;AC4IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ADzIJ;AC2II;;;;;;EACE,gBAAA;ADpIN;ACwIE;;EAEE,eA5GO;EA6GP,gBA3GO;AD3BX;ACwII;EALF;;IAMI,eA/GY;EDrBhB;AACF;ACuIE;;EAEE,eAlHO;EAmHP,gBAjHO;ADpBX;ACuII;EALF;;IAMI,eArHY;EDdhB;AACF;ACsIE;;EAEE,eAxHO;EAyHP,gBAvHO;ADbX;ACsII;EALF;;IAMI,eA3HY;EDPhB;AACF;ACqIE;;EAEE,eA9HO;EA+HP,gBA7HO;ADNX;ACsIE;;EAEE,eAhIO;EAiIP,gBAhIO;ADJX;ACuIE;;EAEE,eAnIO;EAoIP,gBAnIO;ADFX;AC2IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ADzIJ;AC2II;EACE,gBAAA;ADzIN;AC4II;EAXF;IAYI,eAAA;EDzIJ;AACF;AC4IE;;EAEE,UAAA;EACA,SAAA;AD1IJ;AC6IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AD3IJ;;AC+IA;EACE,sBAxNQ;AD4EV;;AC+IA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AD5IF;AC8IE;EALF;IAMI,cAAA;ED3IF;AACF;AC6IE;EACE,iBA1Ka;AD+BjB;AC8IE;EACE,gBApLa;EAqLb,WAAA;AD5IJ;;ACiJE;EACE,kBAAA;AD9IJ;ACiJE;EACE,iBAAA;AD/IJ;;ACoJE;EACE,aAAA;ADjJJ;;ACqJA;EACE,kBAAA;ADlJF;ACoJE;EACE,mBAAA;ADlJJ;ACsJI;EACE,sBAAA;ADpJN;ACwJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ADwEnB;ACwJI;EACE,sBAAA;ADtJN;ACyJI;EAVF;IAWI,eApOoB;ED8ExB;AACF;ACyJE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ADvJJ;ACyJI;EACE,sBAAA;ADvJN;AC0JI;EACE,WAAA;ADxJN;AC2JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ADmMZ;;AC8JA;EACE,mBA1PO;AD+FT;AC6JE;EAHF;IAII,mBAAA;ED1JF;AACF;AC4JE;EACE,mBAAA;AD1JJ;AC6JE;EACE,aArQK;AD0GT;AC6JI;EAHF;IAII,aAAA;ED1JJ;AACF;AC4JI;EACE,aAAA;AD1JN;;AC+JA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AD5JF;AC8JE;EACE,eAAA;AD5JJ;AC+JE;EACE,sCAAA;AD7JJ;ACgKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AD9JJ;;AC6KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AD1KJ;AC4KI;EACE,kBAAA;AD1KN;AC6KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AD3KN;;ACgLA;EACE,8BAAA;AD7KF;;ACgLA;EACE,8BAAA;AD7KF;;ACgLA;EACE,+BAAA;AD7KF;;ACgLA;EACE,8BAAA;AD7KF;;ACgLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AD7KF;AC+KE;EACE,2BAAA;EACA,mBAAA;AD7KJ;ACgLE;EACE,yBAzbiB;EA0bjB,WA1aO;AD4PX;ACiLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AD/KJ;ACkLE;EACE,yBAjckB;EAkclB,cArciB;ADqRrB;ACmLE;EACE,yBAvbS;EAwbT,WA1bO;ADyQX;ACmLI;EACE,6BAAA;ADjLN;;ACsLA;EACE;IACE,uBAAA;EDnLF;ECsLA;IACE,yBAAA;EDpLF;AACF;ACuLA;EACE,8BAAA;ADrLF;;ACwLA;EACE,8BAAA;ADrLF;;ACwLA;EACE,+BAAA;ADrLF;;ACwLA;EACE,8BAAA;ADrLF;;ACwLA;EACE,qBAAA;ADrLF;;ACwLA;EACE,UAAA;ADrLF;ACuLE;EACE,qBAAA;ADrLJ;;ACyLA;EACE,UAAA;ADtLF;;AC0LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ADxLJ;AC2LM;EACE,mBAAA;ADzLR;AC8LE;EACE,2BAAA;AD5LJ;AC+LE;EACE,uBAAA;AD7LJ;ACgME;EACE,mBAAA;AD9LJ;;ACmME;EACE,mBAAA;ADhMJ;ACmME;EACE,yBAAA;ADjMJ;ACoME;EACE,sBAAA;ADlMJ;ACqME;EACE,uBAAA;ADnMJ;ACsME;EACE,oBAAA;ADpMJ;;AA7YA;EAEE,6GAAA;EACA,6BAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AA+YF;;AA3YA;EACE,YAAA;EACA,WAAA;EACA,qBAAA;AA8YF;;AA5YA;EACE,yBAAA;EACA,kBAAA;AA+YF;;AA7YA;EACE,cAAA;AAgZF;;AA9YA;EACE,0BAAA;EACA,WC4CiB;ADqWnB;;AA/YA;EACE,eAAA;AAkZF;;AA7YE;EACI,kBAAA;AAgZN;AA9YE;EACI,uBAAA;AAgZN;AA7YE;EACI,WAAA;EACA,mBAAA;AA+YN;AA9YM;EACI,UAAA;AAgZV;AA3YI;EAuBE,mBC/BgB;EDgChB,8BAAA;EACA,+BAAA;AAuXN;AA/YM;EACE,sBAAA;EACA,mBAAA;AAiZR;AA/YM;EACE,sBAAA;EACA,mBAAA;AAiZR;AAhZQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;AAkZZ;AAjZY;EACI,mBAAA;AAmZhB;AA5YM;EACI,sBAAA;EACA,iBAAA;EACA,YAAA;AA8YV;AA7YU;EACI,uBAAA;AA+Yd;AA5YM;EACI,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AA8YV;AA5YM;EACE,gBCrBW;ADmanB;AA5YM;EACE,WAAA;AA8YR;AA7YQ;EACE,cAAA;AA+YV;AA7YQ;EACI,mBAAA;EACA,sBAAA;AA+YZ;AA3YQ;EACI,mBCjCG;EDkCH,WCpCO;EDqCP,2BAAA;EACA,mBAAA;AA6YZ;AAxYM;EACI,uBAAA;AA0YV;AAnYI;EACI,iCAAA;EACA,2BAAA;EACA,iBAAA;AAqYR;AApYQ;EACI,mBCtDG;AD4bf;AAjYE;;EAEI,wBAAA;AAmYN;AAhYE;EACI,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAkYN;AAhYE;EACI,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAkYN;AAhYE;EACI,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AAkYN;AAhYE;EACG,WAAA;AAkYL;AAjYK;EACG,mBCtHc;ADyftB;AAjYM;;EAEE,iBAAA;AAmYR;AAjYO;;EAEC,kBAAA;AAmYR;AA9XI;EACE,kBAAA;AAgYN;AA/XM;EACE,sBAAA;AAiYR;AA/XM;EACE,aAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WC3HW;ED4HX,2BAAA;EACA,6BAAA;EACA,mCAAA;EACA,2CAAA;AAiYR;AA9XQ;EACE,cAAA;AAgYV;AA3XE;EACE,WAAA;EACA,YAAA;AA6XJ;AA3XE;;EAEE,qBAAA;EACA,mBAAA;AA6XJ;AA3XE;EACE,kBAAA;AA6XJ;AA1XE;EACE,kBAAA;EACA,gBAAA;AA4XJ;AAvXE;EACE,qBAAA;EACA,cAAA;AAyXJ;AAvXE;EACE,kBAAA;AAyXJ;AAvXE;EACE,WAAA;EACA,qBAAA;EACA,mBAAA;AAyXJ;AAvXE;EACE,oBAAA;AAyXJ;AAtXE;EACE,YAAA;AAwXJ;AArXI;EACE,UAAA;EACA,qBAAA;EACA,kBAAA;AAuXN;AArXI;EACE,eAAA;AAuXN;AAnXE;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAqXJ;AAnXE;EACE,2BAAA;EACA,sBAAA;AAqXJ;AAnXE;EACE,mBAAA;EACA,gBAAA;AAqXJ;AApXI;EACE,gBAAA;EACA,mBAAA;AAsXN;AAnXE;EACE,kBAAA;AAqXJ;AAlXE;EACE,0BAAA;AAoXJ;AAjXE;EACE,qBAAA;EACA,WAAA;EACA,WAAA;AAmXJ;AAhXE;EACE,YAAA;EACA,gBAAA;AAkXJ;AAhXE;EACE,YAAA;EACA,cAAA;AAkXJ;AA/WE;EACE,sBAAA;AAiXJ;AA9WE;EACE,WAAA;EACA,SAAA;EACA,cC9QiB;ED+QjB,SAAA;EACA,eAAA;AAgXJ;AA7WE;EACE,sBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;AA+WJ;AA5WE;EACE,oBAAA;EACA,WAAA;EACA,YAAA;AA8WJ;AA3WE;EACE,WAAA;EACA,eAAA;EACA,WAAA;AA6WJ;AA1WE;EACE,WAAA;EACA,eAAA;EACA,UAAA;AA4WJ;AAzWE;EACE,gBAAA;AA2WJ;AAtWE;EACI,kBAAA;EACA,cAAA;EACA,WAAA;AAwWN;AAnWE;EACI,2BAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AAqWN;AAlWE;EACI,qBAAA;AAoWN;AAjWE;EACI,cAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,qBAAA;EAGA,kBAAA;AAmWN;AAhWE;EACI,gBC1Uc;ED2Ud,WC9Sa;ADgpBnB;AA/VE;EACE,8BAAA;AAiWJ;AA9VE;EAEI,8CAAA;EACA,sBAAA;AA+VN;AA3VE;EACI,cAAA;EACA,WAAA;EACA,mBAAA;AA6VN;AA1VE;EACE,gBAAA;AA4VJ;;AAxVA;EAwDI,kBAAA;AAoSJ;AAzVI;;EAEI,qBAAA;GA2VN,eA1VM;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oFAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AA2VR;AAzVI;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;AA2VN;AAzVI;EACI,wBAAA;AA2VR;AAzVI;EACI,4BAAA;AA2VR;AAzVI;EACI,4BAAA;AA2VR;AAzVI;EACI,4BAAA;EACA,eAAA;AA2VR;AAzVI;EACI,4BAAA;AA2VR;AAxVI;EACI,6BAAA;AA0VR;AAxVI;EACI,6BAAA;AA0VR;AAxVI;EACI,6BAAA;AA0VR;AAxVI;EACI,6BAAA;EACA,eAAA;AA0VR;AAxVI;EACI,6BAAA;AA0VR;AAtVI;EACI;;IAEI,mFAAA;IAEA,2BAAA;EAwVV;AACF;;AAnVA;EACI,mBAAA;AAsVJ;AArVI;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAuVN;AAtVM;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAwVR;AAtVM;EACE,iBAAA;EACA,oBAAA;AAwVR;AArVM;EACE,aAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;AAuVR;AArVU;EACA;;IAEE,mBAAA;EAuVV;AACF;AArVQ;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AAuVV;AArVY;EACE,eAAA;AAuVd;AArVY;EACE,gBAAA;AAuVd;AAtVc;EACI,oBAAA;AAwVlB;AAtVc;EACE,eAAA;AAwVhB;AAtVc;EACE,gBAAA;AAwVhB;AAnVM;EACE,iBAAA;EACA,oBAAA;AAqVR;;AA/UA;EACI,kBAAA;EACA,+BAAA;AAkVJ;AAhVQ;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,QAAA;AAkVR;;AA7UI;EACE,gBAAA;AAgVN;AA9UM;EACE,6BAAA;AAgVR;;AA1UA;EACI,gBAAA;AA6UJ;;AA1UA;EACE,gCAAA;AA6UF;;AA1UA;EACI,YAAA;AA6UJ;;AA3UA;EACE,0BAAA;AA8UF;;AAvUE;;;EACE,aAAA;EACA,qBAAA;AA4UJ;;AAxUA;EACE,gBAAA;AA2UF","sourcesContent":["@import './../../../assets/styles/variables';\n\n\n::ng-deep.profile_types {\n  //background-image: url(\"#{$assets}/images/foursight-profile-types.png\") !important;\n  background-image: url(\"#{$assets}/images/foursight-profile-types.svg\") !important;\n  background-color: transparent;\n  background-repeat: no-repeat;\n  width: 34px;\n  height: 15px;\n  margin-left: 6px;\n  //background-size: 175px 46px;\n}\n\n::ng-deep #holder > li {\n  padding: 5px;\n  margin: 2px;\n  display: inline-block;\n}\n::ng-deep #holder > li[data-page] {\n  border: solid #a0a0a0 1px;\n  border-radius: 5px;\n}\n::ng-deep #holder > li.separator:before {\n  content: '...';\n}\n::ng-deep #holder > li.active {\n  background-color: darkblue;\n  color: $color-light-type;\n}\n::ng-deep #holder > li[data-page]:hover {\n  cursor: pointer;\n}\n\n\n::ng-deep{\n  .checkbox {\n      padding-left: 20px;\n  }\n  .pull-right {\n      float: right!important;\n  }\n\n  .ibox-title.profile-heading-2 h5 {\n      width: 100%;\n      vertical-align: top;\n      ul.inline-list {\n          padding: 0;\n      }\n  }\n\n  table.profile-layout.table-striped{\n    tr{\n      td{\n        vertical-align: middle;\n        white-space: nowrap;\n      }\n      th{\n        vertical-align: middle;\n        white-space: nowrap;\n        span.sortby {\n            width: 100%;\n            height: 100%;\n            text-align: right;\n            display: block;\n            position: absolute;\n            right: 0;\n            top: 14px;\n            cursor: pointer;\n            font-size: 16px;\n            &.fname-asc, &.lname-asc, &.email-asc, &.org-asc, &.team-asc, &.profile-asc {\n                top: 8px !important;\n            }\n        }\n      }\n      background: $color-neutral-light;\n      border-left: 1px solid #d0d0d0;\n      border-right: 1px solid #d0d0d0;\n      input{\n          border: 1px solid $color-neutral-mid;\n          padding: 10px 8px;\n          height: 34px;\n          &[type=\"checkbox\"] {\n              height: auto !important;\n          }\n      }\n      select {\n          border: 1px solid $color-neutral-mid;\n          padding: 7px 8px;\n          height: 34px;\n          min-width: 100px;\n      }\n      &:nth-child(odd){\n        background: $color-light-type;\n      }\n      a{\n        color: #333;\n        &:hover{\n          color: #337ab7;\n        }\n        a.label.label-default {\n            background: #474747;\n            color: $color-light-type !important;\n        }\n      }\n      &:first-child{\n        th {\n            background: $fs-dark-grey;\n            color: $color-light-type;\n            padding: 10px 10px 5px 10px;\n            white-space: nowrap;\n        }\n      }\n    }\n    tfoot{\n      tr {\n          border: none !important;\n      }\n    }\n  }\n\n  ::ng-deep\n  #holder{\n    li {\n        border: 1px solid $color-neutral-mid !important;\n        border-radius: 0 !important;\n        padding: 7px 11px;\n        &.active {\n            background: $fs-dark-grey;\n        }\n    }\n  }\n\n  table.profile-layout.table-striped tr input[type=\"date\"]::-webkit-inner-spin-button, \n  table.profile-layout.table-striped tr input[type=\"date\"]::-webkit-outer-spin-button {\n      -webkit-appearance: none;\n  }\n\n  span.invitation-text {\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      width: 160px !important;\n      overflow: hidden;\n      display: block;\n  }\n  span.contact-lists {\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      width: 100px !important;\n      overflow: hidden;\n      display: block;\n  }\n  a.orgs-lists {\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      width: 80px !important;\n      overflow: hidden;\n      display: block;\n  }\n  .selectDataChild {\n     width: 100%;\n     tr:nth-child(odd) {\n        background: $color-neutral-light;\n    }\n      th,\n      td{\n        padding: 5px 10px;\n      }\n       th:last-child,\n      td:last-child{\n        text-align: center;\n      }\n\n  }\n    .reset-input{\n    th{\n      position: relative;\n      input[type=\"search\"]{\n        width: 100% !important;\n      }\n      .reset-close{\n        display: none;\n        position: absolute;\n        top: 0;\n        right: 25px;\n        bottom: 0;\n        margin: auto;\n        border-radius: 50%;\n        background: #ddd;\n        border: none !important;\n        text-align: center;\n        font-size: 14px;\n        padding: 0px !important;\n        height: 16px !important;\n        width: 16px !important;\n        color: $color-light-type;\n        line-height: 1.2 !important;\n        font-family: Arial !important;\n        transform: rotate(45deg) !important;\n        -webkit-transform: rotate(45deg) !important;\n      }\n      &:hover{\n        .reset-close{\n          display: block;\n        }\n      }   \n    }   \n  }\n  #templates{\n    width: auto;\n    height: 37px;\n  }\n  .btn-export-section,\n  #templates{\n    display: inline-block;\n    vertical-align: top;\n  }\n  .btn-export-section{\n    padding-left: 15px;\n  }\n  \n  ::ng-deep .btn-section{\n    text-align: center;\n    margin-top:15px;\n    // button{\n    //   margin: 0 20px;\n    // }\n  }\n  ::ng-deep.save-btn{\n    display: inline-block;\n    margin: 0 10px;\n  }\n  ::ng-deep.members{\n    text-align: center;\n  }\n  ::ng-deep#parent-orgs{\n    width: auto;\n    display: inline-block;\n    margin-bottom: 15px;\n  }\n  ::ng-deep.groups{\n    padding-bottom: 10px;\n\n  }\n  ::ng-deep.groups-content .modal-dialog{\n    width: 750px;\n  }\n  .column-up{\n    .list-group-item{\n      width: 48%;\n      display: inline-block;\n      margin-right: 10px;\n    }\n    .list-group-item:nth-child(2n){\n      margin-right: 0;\n    }\n  }\n\n  .profile-layout th button {\n    display: block;\n    max-width: 94px;\n    width: 100px;\n    margin-bottom: 5px;\n  }\n  table.profile-layout.table-striped input[type=\"search\"] {\n    min-width: 100px !important;\n    width: 100% !important;\n  }\n  .inner-form-group {\n    margin-bottom: 15px;\n    margin-top: 15px;\n    select {\n      margin-top: 10px;\n      margin-bottom: 10px;\n    }\n  }\n  .add-btn-pop{\n    margin-right: 10px;\n  }\n\n  .cancel-add-to-org{\n    margin-top: 0px !important;\n  }\n\n  .d-inline {\n    display: inline-block;\n    width: auto;\n    clear: none;\n  }\n\n  .tick:before {\n    content: \"\\2713\";\n    color: darkgreen;\n  }\n  .cross:before {\n    content: \"\\2717\";\n    color: crimson;\n  }\n\n  .wide-per-page{\n    width: 78px !important;\n  }\n\n  legend {\n    width: auto;\n    border: 0;\n    color: $body-content-color;\n    margin: 0;\n    font-size: 16px;\n  }\n\n  fieldset{\n    border: 1px solid #ddd;\n    padding: 18px;\n    width: 100%;\n    margin-bottom: 15px;\n  }\n\n  .form-group.session2 select {\n    margin: 0 !important;\n    width: 74px;\n    height: 35px;\n  }\n\n  .form-group.session1{\n    float: left;\n    padding: 0 10px;\n    width: 100%;\n  }\n\n  .form-group.session2{\n    float: left;\n    padding: 0 10px;\n    width: 30%;\n  }\n\n  .add-session{\n    margin-top: 15px;\n  }\n\n\n\n  .wizard > .steps {\n      position: relative;\n      display: block;\n      width: 100%;\n  }\n\n\n\n  .wizard ul, .tabcontrol ul {\n      list-style: none !important;\n      padding: 0;\n      margin: 0;\n      text-align: center;\n  }\n\n  .wizard > .steps > ul > li, .wizard > .actions > ul > li {\n      display: inline-block;\n  }\n\n  .wizard > .steps a, .wizard > .steps a:hover, .wizard > .steps a:active {\n      display: block;\n      width: auto;\n      margin: 0 0.5em 0.5em;\n      padding: 8px;\n      text-decoration: none;\n      -webkit-border-radius: 5px;\n      -moz-border-radius: 5px;\n      border-radius: 5px;\n  }\n\n  .wizard > .steps .done a, .wizard > .steps .done a:hover, .wizard > .steps .done a:active {\n      background: $color-neutral-mid;\n      color: $color-light-type;\n  }\n\n  .wizard > .steps .active a{\n    background: $body-content-color !important;\n  }\n\n  ::ng-deep.previous-btn {\n      // margin-right: 10px;\n      background-color: $develop-color !important;\n      color: $color-light-type !important;\n  }\n\n\n  .inner-form-group input[type=\"text\"] {\n      display: block;\n      width: 100%;\n      margin-bottom: 15px;\n  }\n\n  .team-table{\n    margin-top: 15px;\n  }\n}\n\n::ng-deep{\n\n\n    .icheckbox_square-green,\n    .iradio_square-green {\n        display: inline-block;\n        *display: inline;\n        vertical-align: middle;\n        margin: 0;\n        padding: 0;\n        width: 22px;\n        height: 22px;\n        background: url('#{$assets}/images/green.png') no-repeat;\n        border: none;\n        cursor: pointer;\n        margin-left: 0;\n    }\n    label{\n      vertical-align: middle;\n      margin-bottom: 0;\n      margin-left: 7px;\n    }\n    .icheckbox_square-green {\n        background-position: 0 0;\n    }\n    .icheckbox_square-green.hover {\n        background-position: -24px 0;\n    }\n    .icheckbox_square-green.checked {\n        background-position: -48px 0;\n    }\n    .icheckbox_square-green.disabled {\n        background-position: -72px 0;\n        cursor: default;\n    }\n    .icheckbox_square-green.checked.disabled {\n        background-position: -96px 0;\n    }\n\n    .iradio_square-green {\n        background-position: -120px 0;\n    }\n    .iradio_square-green.hover {\n        background-position: -144px 0;\n    }\n    .iradio_square-green.checked {\n        background-position: -168px 0;\n    }\n    .iradio_square-green.disabled {\n        background-position: -192px 0;\n        cursor: default;\n    }\n    .iradio_square-green.checked.disabled {\n        background-position: -216px 0;\n    }\n\n    /* HiDPI support */\n    @media (-o-min-device-pixel-ratio: 5/4), (-webkit-min-device-pixel-ratio: 1.25), (min-resolution: 120dpi) {\n        .icheckbox_square-green,\n        .iradio_square-green {\n            background-image: url('#{$assets}/images/green@2x.png');\n            -webkit-background-size: 240px 24px;\n            background-size: 240px 24px;\n        }\n    }\n}\n\n\n.manage-members-wrapper {\n    margin-bottom: 20px;\n    .manage-inner{\n      float: none;\n      margin-left: auto;\n      margin-right: auto;\n      margin-bottom: 15px;\n      h2{\n        font-weight: 600;\n        margin-top: 0;\n        margin-bottom: 30px;\n      }\n      h3{\n        padding-top: 10px;\n        padding-bottom: 10px;\n\n      }\n      .inner-block{\n        display: flex;\n        display: -ms-flexbox;\n        flex-wrap:wrap;\n        -ms-flex-wrap:wrap;\n        \n          @media screen and (max-width: 767px){\n          .col-sm-4,\n          .col-sm-6{\n            margin-bottom: 15px;\n            }\n          }\n        .inner-single-box{  \n          padding:15px;  \n          border: 3px solid $border-color;\n          height: 100%;\n          border-radius: 5px;\n\n            i{\n              font-size: 60px;\n            }\n            ul{\n              margin-top: 40px;\n              li:first-child{\n                  padding-bottom: 10px;\n                }\n              li:nth-child(2) {\n                font-size: 14px;\n              }\n              li:nth-child(3) {\n                margin-top: 10px;\n              }\n            }\n          }\n      } \n      .bottom-member {\n        padding-top: 15px;\n        padding-bottom: 15px;\n      }\n    }\n  }\n  .add-mbr-block{\n\n.inner-single-box {\n    position: relative;\n    padding-bottom: 35px !important;\n    }\n        h5 {\n        position: absolute;\n        left: 0;\n        bottom: 4px;\n        right: 0;\n    }\n  } \n.manage-profile-txt{\n   tr{\n    td{\n      text-align:   left;\n    }\n      td:last-child, th:last-child {\n        text-align: center !important;\n    }\n   } \n  \n}\n\n.ibox.ibox-member-dropdown {\n    box-shadow: none;\n}\n\n.border-green{\n  border-color: #86b74b !important;\n}\n\n::ng-deep .iradio_square-green {\n    float: right;\n}\n.fname-column, .lname-column{\n  text-transform: capitalize;\n}\n\n.first_name,\n.last_name,\n.wide-per-page {\n\n  &:focus {\n    outline: none;\n    border-color: #1ab394;\n  }\n}\n\n.table-responsive {\n  overflow-x: auto;\n}","// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
